import React, { useState } from 'react'

import { isFunction } from 'lodash'

import FilesUpload from '../Files/FilesUpload'
import FileTooLargeMessage from '../../shared/Messages/FileTooLargeMessage'
import { isFileTooLarge } from '../../../utils/files'

const FilesUploader = ({ onUpload, ...props }) => {
  const [tooLargeFile, setTooLargeFile] = useState(null)

  const handleUpload = (file) => {
    if (isFunction(onUpload)) {
      if (isFileTooLarge(file)) {
        setTooLargeFile(file)
      } else {
        setTooLargeFile(null)
        onUpload(file)
      }
    }

    return false
  }

  return (
    <>
      <FilesUpload {...props} onUpload={handleUpload} />
      <FileTooLargeMessage file={tooLargeFile} />
    </>
  )
}

export default FilesUploader
